import { FocusEvent } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import TextField from '@material-ui/core/TextField';

interface FormAutoCompleteProps {
  id: string;
  label: string;
  value: string | null;
  options: { label: string; value: string }[];
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  loading?: boolean;
  hasNoData?: boolean;
  onChange: (newValue: string) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

interface AutoCompleteOption {
  label: string;
  value: string;
}

export const FormAutoComplete = ({
  id,
  label,
  value,
  options,
  placeholder,
  disabled,
  required,
  error,
  loading,
  hasNoData,
  onChange,
  onBlur,
}: FormAutoCompleteProps) => {
  const selectedOption =
    options.find((option: AutoCompleteOption) => option.value === value) ??
    null;
  return (
    <Box className="apm-form-group">
      <Typography component="label" htmlFor={id} className="apm-form-label">
        {label}
        {required && <span className="apm-required">*</span>}
      </Typography>

      <Autocomplete<AutoCompleteOption>
        id={id}
        options={options}
        value={selectedOption}
        disabled={disabled}
        loading={loading}
        loadingText={placeholder || 'Loading...'}
        noOptionsText={placeholder || 'No options'}
        getOptionLabel={(option: AutoCompleteOption) => option.label}
        getOptionSelected={(
          option: AutoCompleteOption,
          selectedValue: AutoCompleteOption,
        ) => option.value === selectedValue.value}
        onChange={(_, newValue) => onChange(newValue ? newValue.value : '')}
        renderInput={params => (
          <TextField
            {...params}
            name={id}
            placeholder={placeholder}
            size="small"
            variant="outlined"
            required={required}
            error={!!error || !!hasNoData}
            helperText={error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            onBlur={event => {
              if (options.length === 0) return;
              onBlur?.(event);
            }}
          />
        )}
      />
    </Box>
  );
};
